import { render, staticRenderFns } from "./AssignCvApproverDialog.vue?vue&type=template&id=433bc7a1&scoped=true"
import script from "./AssignCvApproverDialog.vue?vue&type=script&lang=js"
export * from "./AssignCvApproverDialog.vue?vue&type=script&lang=js"
import style0 from "./AssignCvApproverDialog.vue?vue&type=style&index=0&id=433bc7a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433bc7a1",
  null
  
)

export default component.exports